import { ICintorinConfig } from "./interfaces";

declare const CintorinConfig: ICintorinConfig;

export type LocalizationIndex = "messageReported" | "messageReportError" | "addMessageForbidden" | "addMessageError" 
    | "settingShowPreview" |  "settingShowArrows" | "settingShowOrnaments"
    | "placeNotFound" | "mapLoadingError" | "printCityLabel" | "printCemeteryLabel" | "printCreatedBy" | "printLastModifiedLabel" | "printLastModifiedExplanation"
    | "controlLayers" | "controlPrint" | "controlTransparency" | "controlOrthomapUnavailable" | "controlFilter" | "controlGraveType" | "controlTools"
    | "controlUnpaidGravesFilter" | "controlProjectedGravesFilter" | "controlNoContractFilter" | "controlEmptyGravesFilter"
    | "controlZoomIn" | "controlZoomOut" | "controlOverviewMap" 
    | "controlLocationDisabled" | "controlLocationSearching" | "controlLocationError" | "controlLocationFixed" | "controlGoToLocation"
    | "mapLoading";

export function getLocalizedText(index: LocalizationIndex):string {
    switch (CintorinConfig.language) {
        case "sk":
            return getSlovakText(index);
        case "cz":
            return getCzechText(index);
        case "en":
            return getEnglishText(index);
        case "de":
            return getGermanText(index);
    }
}

function getSlovakText(index: LocalizationIndex):string {
    switch (index) {
        case "messageReported": return "Odkaz bol nahlásený administrátorovi";
        case "messageReportError": return "Počas nahlasovania nevhodného odkazu došlo k chybe, skúste zopakovať nahlásenie neskôr.";
        case "addMessageForbidden": return "Nepodarilo sa pridať memoart, nakoľko text odkazu alebo podpis obsahuje nepovolené znaky.";
        case "addMessageError": return "Nepodarilo sa pridať memoart, v prípade pretrvávajúcich problémov kontaktujte administrátora (chyba: #)";
        case "placeNotFound": return "Pre záznam nie je k dispozícii poloha na mape";
        case "mapLoadingError": return "Počas načítavania došlo k chybe, skúste znovu načítať stránku.";
        case "printCityLabel": return "Obec: ";
        case "printCemeteryLabel": return "Cintorín: ";
        case "printCreatedBy": return "Vyhotovil: ";
        case "printLastModifiedLabel": return "Posledná aktualizácia mapy: ";
        case "printLastModifiedExplanation": return "(aktualizáciu vykonáva správca IS cintorína)";
        case "settingShowPreview": return "Zobraziť náhľad hrobu na mape";
        case "settingShowArrows": return "Zobraziť šípky na posúvanie mapy";
        case "settingShowOrnaments": return "Zobraziť na mape memoarty";
        case "controlPrint": return "Tlač";
        case "controlLayers": return "Vrstvy";
        case "controlOrthomapUnavailable": return "ortofotomapa nie je k dispozícii";
        case "controlTransparency": return "Priehľadnosť";
        case "controlTools": return "Nástroje";
        case "controlFilter": return "Filter";
        case "controlGraveType": return "Typy hrobov:";
        case "controlEmptyGravesFilter": return "Voľné hroby";
        case "controlNoContractFilter": return "Hroby bez zmluvy";
        case "controlUnpaidGravesFilter": return "Nezaplatené hroby";
        case "controlProjectedGravesFilter": return "Projektované hroby";
        case "controlZoomIn": return "Zoom in";
        case "controlZoomOut": return "Zoom out";
        case "controlOverviewMap": return "Prehľadová mapa";
        case "controlLocationDisabled": return "Zobrazenie aktuálnej polohy vypnuté";
        case "controlLocationSearching": return "Hľadám aktuálnu polohu";
        case "controlLocationError": return "Hľadanie zlyhalo";
        case "controlLocationFixed": return "Zobrazenie aktuálnej polohy zapnuté";
        case "controlGoToLocation": return "Presunúť mapu na aktuálnu polohu";
        case "mapLoading": return "Načítavam mapu";
    }
}

function getCzechText(index: LocalizationIndex):string {
    switch (index) {
        case "messageReported": return "Odkaz byl nahlásen administrátorovi";
        case "messageReportError": return "Během nahlasování nevhodného odkazu došlo k chybě, zkuste zopakovat nahlásení později.";
        case "addMessageForbidden": return "Nepodařilo sa přidat memoart, protože text odkazu nebo podpis obsahuje nepovolené znaky.";
        case "addMessageError": return "Nepodařilo sa přidat memoart, v případe pretrvávajících problémů kontaktujte administrátora (chyba: #)";
        case "placeNotFound": return "Pro záznam není k dispozici poloha na mapě";
        case "mapLoadingError": return "Během načítání došlo k chybě, zkuste znovu načítat stránku.";
        case "printCityLabel": return "Obec: ";
        case "printCemeteryLabel": return "Hřbitov: ";
        case "printCreatedBy": return "Vyhotovil: ";
        case "printLastModifiedLabel": return "Posledná aktualizace mapy: ";
        case "printLastModifiedExplanation": return "(aktualizaci vykonává správce IS hřbitova)";
        case "settingShowPreview": return "Zobrazit náhled hrobu na mapě";
        case "settingShowArrows": return "Zobrazit šipky pro posunutí mapy";
        case "settingShowOrnaments": return "Zobrazit na mapě memoarty";
        case "controlPrint": return "Tisk";
        case "controlLayers": return "Vrstvy";
        case "controlOrthomapUnavailable": return "ortofotomapa není k dispozici";
        case "controlTransparency": return "Průhlednost";
        case "controlTools": return "Nástroje";
        case "controlFilter": return "Filter";
        case "controlGraveType": return "Typy hrobů:";
        case "controlEmptyGravesFilter": return "Volné hroby";
        case "controlNoContractFilter": return "Hroby bez zmluvy";
        case "controlUnpaidGravesFilter": return "Nezaplacené hroby";
        case "controlProjectedGravesFilter": return "Projektované hroby";
        case "controlZoomIn": return "Zoom in";
        case "controlZoomOut": return "Zoom out";
        case "controlOverviewMap": return "Orientační mapa";
        case "mapLoading": return "Načítávam mapu";
    }
}

function getEnglishText(index: LocalizationIndex):string {
    switch (index) {
        case "messageReported": return "Message has been reported to site admin";
        case "messageReportError": return "An error occurred while reporting the message, please try again later.";
        case "addMessageForbidden": return "Could not add memoart, due to message or signature containing invalid characters.";
        case "addMessageError": return "Could not add memoart, if issues persist please contact admin. (error: #)";
        case "placeNotFound": return "Map location not available for given record";
        case "mapLoadingError": return "An error occurred while loading, please try refreshing the page.";
        case "printCityLabel": return "City: ";
        case "printCemeteryLabel": return "Cemetery: ";
        case "printCreatedBy": return "Created by: ";
        case "printLastModifiedLabel": return "Map last modified: ";
        case "printLastModifiedExplanation": return "(updates are made by cemetery admin)";
        case "settingShowPreview": return "Display gravesite preview on map";
        case "settingShowArrows": return "Display arrows to move around map";
        case "settingShowOrnaments": return "Display memoarts on map";
        case "controlPrint": return "Print";
        case "controlLayers": return "Layers";
        case "controlOrthomapUnavailable": return "orthophoto map not available";
        case "controlTransparency": return "Transparency";
        case "controlTools": return "Tools";
        case "controlFilter": return "Filter";
        case "controlGraveType": return "Grave types:";
        case "controlEmptyGravesFilter": return "Unoccupied graves";
        case "controlNoContractFilter": return "Graves without contract";
        case "controlUnpaidGravesFilter": return "Graves with unpaid lease";
        case "controlProjectedGravesFilter": return "Projected graves";
        case "controlZoomIn": return "Zoom in";
        case "controlZoomOut": return "Zoom out";
        case "controlOverviewMap": return "Overview map";
        case "mapLoading": return "Loading map";
    }
}

function getGermanText(index: LocalizationIndex):string {
    switch (index) {
        case "messageReported": return "Der Link wurde dem Administrator gemeldet";
        case "messageReportError": return "Während der Meldung eines inkorrekten Links ist ein Fehler aufgetreten, bitte versuchen Sie, sich zu einem späteren Zeitpunkt erneut anzumelden.";
        case "addMessageForbidden": return "Das Hinzufügen des Gedenkartikels ist fehlgeschlagen, weil der Text des Links oder die Signatur unzulässige Zeichen enthält. ";
        case "addMessageError": return "Das Hinzufügen des Gedenkartikels ist fehlgeschlagen, sollten die Probleme andauern, kontaktieren Sie bitte den Administrator (Fehler: #)";
        case "placeNotFound": return "Für den Eintrag ist kein Standort auf dem Friedhofsplan verfügbar";
        case "mapLoadingError": return "Beim Abrufen ist ein Fehler aufgetreten, versuchen Sie bitte die Webseite erneut abzurufen.";
        case "printCityLabel": return "Gemeinde: ";
        case "printCemeteryLabel": return "Friedhof: ";
        case "printCreatedBy": return "Erstellt von: ";
        case "printLastModifiedLabel": return "Letzte Aktualisierung des Friedhofsplans: ";
        case "printLastModifiedExplanation": return "(Aktualisierung durch den IT-Verwalter des Friedhofs)";
        case "settingShowPreview": return "Grabansicht auf dem Friedhofsplan anzeigen";
        case "settingShowArrows": return "Pfeiltasten zum Verschieben des Friedhofsplans anzeigen";
        case "settingShowOrnaments": return "Gedenkartikel auf dem Friedhofsplan anzeigen";
        case "controlPrint": return "Ausdrücken";
        case "controlLayers": return "Schichten";
        case "controlOrthomapUnavailable": return "Keine Luftbildkarte verfügbar";
        case "controlTransparency": return "Transparenz";
        case "controlTools": return "Instrumente";
        case "controlFilter": return "Filter";
        case "controlGraveType": return "Grabarten";
        case "controlEmptyGravesFilter": return "Freie Grabstellen";
        case "controlNoContractFilter": return "Vertragslose Gräber";
        case "controlUnpaidGravesFilter": return "Unbezahlte Gräber";
        case "controlProjectedGravesFilter": return "Projektierte Gräber";
        case "controlZoomIn": return "Zoom in";
        case "controlZoomOut": return "Zoom out";
        case "controlOverviewMap": return "Übersichtskarte";
        case "mapLoading": return "Friedhofsplan laden";
    }
}